import { ColorEnum } from '@/constants/color'
import CheckmarkIcon from '@/features/ui/icons/components/CheckmarkIcon'
import { FC } from 'react'
import Svg, { Circle, G } from 'react-native-svg'

const size = 80
const center = size / 2
const iconSize = 56
const iconPosition = center - iconSize / 2

const SuccessIcon: FC = () => {
    return (
        <Svg height={size} width={size} style={{ alignItems: 'center', justifyContent: 'center' }}>
            <Circle
                fill={ColorEnum.Transparent}
                cx={center}
                cy={center}
                r={39}
                stroke={ColorEnum.WHITE}
                strokeWidth={2}
            />
            <G transform={`translate(${iconPosition}, ${iconPosition})`}>
                <CheckmarkIcon height={iconSize} width={iconSize} fill={ColorEnum.WHITE} />
            </G>
        </Svg>
    )
}

export default SuccessIcon
